export default ({medias}) => ({
    limitAllowed: 15,
    medias,
    get mediasIsNotEmpty() {
       return this.medias.length > 0;
    },
    get limitFileSize() {
        return 5 * 1024 * 1024 * 1024;
    },
    get limitReached() {
        return this.limitAllowed < 1;
    },
    get imageMimes() {
        return ['image/jpeg', 'image/gif', 'image/png'];
    },
    get videoMimes() {
        return ['video/mp4'];
    },
    get allowedMimetypes() {
        return [...this.imageMimes, ...this.videoMimes];
    },
    fileExtension(file) {
        const pieces = file.name.split('.');

        return pieces[pieces.length - 1];
    },
    fileSizeIsBelow5GB(fileSize) {
        return fileSize <= this.limitFileSize;
    },
    mapFile(file) {
        const media = {
            id: Math.random().toString(36).substring(2, 9),
            description: '',
            tags: [],
            new: true,
        }

        const extension = this.fileExtension(file);

        if (file.name.length > 255) {
            const newFilename = `${file.name.slice(0, 250)}.${extension}`;

            file = new File([file], newFilename, {
                type: file.type,
                lastModified: file.lastModified
            });
        }

        media.file = file;
        media.url = URL.createObjectURL(file);
        media.type = this.imageMimes.includes(file.type) ? 'photo' : 'video';
        media.original_name = file.name;

        return media;
    },
    urlIsFilled(media) {
        return media.thumbnailUrl !== null && media.thumbnailUrl !== '';
    },
    mediaIsPhoto(media) {
        return media.type === 'photo';
    },
    handleFilesAdded(event) {
        if (this.limitAllowed < 1) {
            window.toast({
                type: 'error',
                message: 'Only 15 media items are allowed on portfolio.'
            });

            return;
        }

        const {files} = event.detail;

        const filteredFiles = files.filter(file => {
            return this.allowedMimetypes.includes(file.type) && this.fileSizeIsBelow5GB(file.size)
        });

        if (filteredFiles.length !== files.length) {
            window.toast({
                type: 'error',
                message: 'Some media were rejected for invalid mime types or size over 5GB.'
            });
        }

        if (filteredFiles.length < 1) {
            return;
        }

        const first15Files = filteredFiles.slice(0, this.limitAllowed);

        if (filteredFiles.length !== first15Files.length) {
            window.toast({
                type: 'error',
                message: 'Only 15 media items are allowed on portfolio.'
            });
        }

        const mappedFiles = first15Files.map(this.mapFile.bind(this));

        mappedFiles.sort((firstFile, secondFile) => firstFile.file.size - secondFile.file.size);

        this.limitAllowed = Math.max(this.limitAllowed - mappedFiles.length, 0);

        this.$dispatch('set-is-uploading-media', {isUploading: true});

        this.$dispatch('application-portfolio-medias-added', {medias: mappedFiles});
    },
    handleMediaUploaded(event) {
        let medias = this.medias.map(media => structuredClone(Alpine.raw(media)));

        const mediaIndex = medias.findIndex(media => media.id === event.detail.media.id);

        if (mediaIndex !== -1) {
            medias[mediaIndex] = event.detail.media;

            window.toast({message: 'Media updated successfully!'});
        } else {
            medias.push(event.detail.media);
        }

        medias.sort((firstMedia, secondMedia) => secondMedia.id - firstMedia.id);

        this.medias = medias;

        this.$dispatch('update-carousel-items-quantity', { itemsQuantity: this.medias.length });
    },
    handleMediaUploadCanceled() {
        this.limitAllowed += 1;

        if (this.limitAllowed > 15) {
            this.limitAllowed = 15;
        }
    },
    handleMediasUpdated(event) {
        this.medias = [...event.detail.medias];
    },
    handleMediaDeleted(event) {
        this.medias = this.medias.filter(media => media.id !== event.detail.mediaId);
        this.limitAllowed = Math.min(this.limitAllowed + 1, 15);
        this.$dispatch('update-carousel-can-scroll');
    },
    handleMediaRemovedFromUpload() {
        this.limitAllowed = Math.min(this.limitAllowed + 1, 15);
    },
    init() {
        this.limitAllowed -= this.medias.length;
    }
})
